var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5585 6.02L12.4785 6.94L3.41854 16H2.49854V15.08L11.5585 6.02ZM15.1585 0C14.9085 0 14.6485 0.1 14.4585 0.29L12.6285 2.12L16.3785 5.87L18.2085 4.04C18.5985 3.65 18.5985 3.02 18.2085 2.63L15.8685 0.29C15.6685 0.09 15.4185 0 15.1585 0ZM11.5585 3.19L0.498535 14.25V18H4.24854L15.3085 6.94L11.5585 3.19Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButtonIcon);
export default __webpack_public_path__ + "static/media/editButtonIcon.9dead9de40580b001ecc16e10c57f37e.svg";
export { ForwardRef as ReactComponent };